import { RequestDTO } from './request-dto';

export interface PerformedByRequestDTO extends RequestDTO {
    onBehalf?: string;
}

export interface UserIdRequestDTO extends RequestDTO {
    userId?: number;
}
